var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.82 8.98713L17.47 12.8471C17.1 13.1071 16.61 13.0971 16.26 12.8171L12.1 9.48713L8.43 12.7771C8.24 12.9471 8 13.0271 7.76 13.0271C7.49 13.0271 7.21 12.9171 7.02 12.6971C6.65 12.2871 6.68 11.6571 7.09 11.2871L11.39 7.42713C11.76 7.10713 12.3 7.08713 12.68 7.39713L16.91 10.7771L21.65 7.36713C22.1 7.03713 22.73 7.13713 23.05 7.58713C23.37 8.03713 23.27 8.66713 22.82 8.98713ZM29 0.682129H1C0.448 0.682129 0 1.13013 0 1.68213C0 2.23513 0.448 2.68213 1 2.68213H2.11V16.6771C2.11 18.3271 3.45 19.6771 5.11 19.6771H13.224L8.305 27.7991C8.019 28.2721 8.171 28.8861 8.643 29.1731C8.805 29.2711 8.984 29.3171 9.16 29.3171C9.498 29.3171 9.828 29.1461 10.016 28.8351L15 20.6051L19.984 28.8351C20.172 29.1461 20.502 29.3171 20.841 29.3171C21.017 29.3171 21.195 29.2711 21.358 29.1731C21.83 28.8861 21.981 28.2721 21.695 27.7991L16.777 19.6771H24.89C26.55 19.6771 27.89 18.3271 27.89 16.6771V2.68213H29C29.552 2.68213 30 2.23513 30 1.68213C30 1.13013 29.552 0.682129 29 0.682129Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsIcon);
export default __webpack_public_path__ + "static/media/analytics-icon.9a4ad1788d209c4a83e370165850743c.svg";
export { ForwardRef as ReactComponent };